import React from 'react';
import {
    AboutSection,
    AboutContainer,
    HeadingText,
    SubTitle,
    Paragraph
} from './AboutElement';

const About = () => {
    return (
        <AboutSection id='/About'>
            <HeadingText>About <span>Us</span></HeadingText>
            <AboutContainer>
                <SubTitle>Crafting Excellence</SubTitle>
                <Paragraph>
                    Prorenova was founded with a simple mission: to deliver exceptional carpentry and renovation services that exceed expectations. With a team of skilled craftsmen and a commitment to quality, we’ve become a trusted name in Uusimaa, Finland for all things carpentry.
                </Paragraph>
                <Paragraph>
                    From restaurant renovations to custom sofa builds, wooden decks, and pergolas, we take pride in every project we undertake. Our attention to detail, dedication to customer satisfaction, and use of premium materials sets us apart. Whether it’s a small repair or a full-scale renovation, we treat every job with the same level of care and professionalism.
                </Paragraph>
                <Paragraph>
                    Let us bring your ideas to life – because your space deserves the best.
                </Paragraph>
            </AboutContainer>
        </AboutSection>
    )
}

export default About;
